// Main entry point for Session management/info
import * as actions from './actions';
import reducer, * as select from './reducers';

// Export anything we need to reverence outside of the /session/ namespace
export const ACTIONS = actions;
export const SessionReducer = reducer;
export const SessionSelect = select;



// WEBPACK FOOTER //
// ./src/session/index.js